document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tab-btn");
  const tabPanes = document.querySelectorAll(".tab-pane");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      // Deactivate all tabs
      tabs.forEach((t) => t.classList.remove("active"));
      tabPanes.forEach((pane) => pane.classList.remove("active"));

      // Activate clicked tab
      tab.classList.add("active");
      const targetPane = document.getElementById(tab.getAttribute("data-tab"));
      targetPane.classList.add("active");
    });
  });

  const accordions = document.querySelectorAll(".accordion-header");
  accordions.forEach((accordion) => {
    accordion.addEventListener("click", () => {
      const body = accordion.nextElementSibling;

      if (body.style.display === "block") {
        body.style.display = "none";
        accordion.classList.remove("open"); // Remove 'open' class when closed
      } else {
        document
          .querySelectorAll(".accordion-body")
          .forEach((b) => (b.style.display = "none"));
        document
          .querySelectorAll(".accordion-header")
          .forEach((a) => a.classList.remove("open")); // Remove 'open' class from all accordion headers
        body.style.display = "block";
        accordion.classList.add("open"); // Add 'open' class when this accordion is opened
      }
    });
  });
});

const str = "A B C \t D \n E";
const whitespaceRemoved = str.replace(/\s/g, "");
console.log(whitespaceRemoved); // ABC

// Gift product add in cart
$(document).on("click", ".add_free_gift", function () {
  var variantId = $(this).data("id");
  var $button = $(this);
  $button.addClass("loading");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: variantId,
    },
    dataType: "json",
    success: function (cart) {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );
      $button.removeClass("loading");
    },
    error: function (xhr, status, error) {
      console.error("Error adding product to cart:", error);
      $button.removeClass("loading");
    },
  });
});

// Add class for sticky header
$(document).ready(function () {
  var offset = 50;
  var header = $("store-header");
  $(window).scroll(function () {
    if ($(this).scrollTop() > offset) {
      header.addClass("is_sticky_header");
      $("body").addClass("custom_tooltip_drawer");
    } else {
      header.removeClass("is_sticky_header");
      $("body").removeClass("custom_tooltip_drawer");
    }
  });
});

$(document).ready(function () {
  var offset = 82;
  var headers = $("store-header");
  $(window).scroll(function () {
    if ($(this).scrollTop() > offset) {
      $("body").addClass("hide_z_index");
    } else {
      $("body").removeClass("hide_z_index");
    }
  });
});

// $(document).ready(function () {
//   // Check localStorage for filter state
//   if (localStorage.getItem("filter_open") === "true") {
//     $(".product-facet__aside").show();
//     $(".custom_featured_collection").addClass("filter_open_list");
//   }

//   $(".click_heading").on("click", function () {
//     $(".product-facet__aside").toggle();
//     $(".custom_featured_collection").toggleClass("filter_open_list");

//     // Store the filter state in localStorage
//     if ($(".custom_featured_collection").hasClass("filter_open_list")) {
//       localStorage.setItem("filter_open", "true");
//     } else {
//       localStorage.setItem("filter_open", "false");
//     }
//   });

//   function adjustFilterDisplay() {
//     if ($(window).width() < 992) {
//       $(".product-facet__aside").css("display", "");
//     } else {
//       if (!$(".custom_featured_collection").hasClass("filter_open_list")) {
//         $(".product-facet__aside").css("display", "none");
//       }
//     }
//   }

//   adjustFilterDisplay();
//   $(window).on("resize", adjustFilterDisplay);
// });

$(document).ready(function () {
  let currentCollection = window.location.pathname;

  // Check sessionStorage for filter state and collection
  if (sessionStorage.getItem("filter_open") === "true" && sessionStorage.getItem("currentCollection") === currentCollection) {
    $(".product-facet__aside").show();
    $(".custom_featured_collection").addClass("filter_open_list");
  } else {
    // Reset filter state when navigating to a new collection
    sessionStorage.removeItem("filter_open");
    sessionStorage.setItem("currentCollection", currentCollection);
  }

  $(".click_heading").on("click", function () {
    $(".product-facet__aside").toggle();
    $(".custom_featured_collection").toggleClass("filter_open_list");

    // Store the filter state in sessionStorage
    if ($(".custom_featured_collection").hasClass("filter_open_list")) {
      sessionStorage.setItem("filter_open", "true");
    } else {
      sessionStorage.setItem("filter_open", "false");
    }
  });

  function adjustFilterDisplay() {
    if ($(window).width() < 992) {
      $(".product-facet__aside").css("display", "");
    } else {
      if (!$(".custom_featured_collection").hasClass("filter_open_list")) {
        $(".product-facet__aside").css("display", "none");
      }
    }
  }

  adjustFilterDisplay();
  $(window).on("resize", adjustFilterDisplay);
});



// Add class in body for different O.S
var OSName = "";
if (navigator.appVersion.indexOf("Win") !== -1) {
  OSName = "Windows";
} else if (navigator.appVersion.indexOf("Mac") !== -1) {
  OSName = "MacOS";
} else if (navigator.appVersion.indexOf("X11") !== -1) {
  OSName = "UNIX";
} else if (navigator.appVersion.indexOf("Linux") !== -1) {
  OSName = "Linux";
} else {
  OSName = "Unknown OS";
}
document.body.classList.add(OSName.toLowerCase());

// Product Recomendation Tabs
function tabclick(params, clickedTab) {
  const recom_pro = document.querySelector(".recommended_product");
  const rec_view = document.querySelector(".recently_viewed");
  if (params === "recommended_product") {
    recom_pro.style.display = "block";
    rec_view.style.display = "none";
  } else if (params === "recent_views") {
    recom_pro.style.display = "none";
    rec_view.style.display = "block";
  }
  document.querySelectorAll(".tab-item").forEach((tab) => {
    tab.classList.remove("active");
  });
  clickedTab.classList.add("active");
}

// Get the button and tooltip elements
const infoBtn = document.querySelector(".info-btn");
const tooltipb = document.querySelector(".tooltip");
const tooltip = document.getElementById("info-tooltip");
const closeBtn = document.querySelector(".close-btn");

function infobtn(button) {
  const tooltip = button.parentElement.querySelector(".tooltip");
  if (tooltip) {
    tooltip.style.display = tooltip.style.display === "block" ? "none" : "block";
  }
}

if (infoBtn) {
  // Toggle the tooltip when the button is clicked
  infoBtn.addEventListener("click", function (event) {
    event.stopPropagation(); // Prevent event bubbling
    tooltip.style.display = tooltip.style.display === "block" ? "none" : "block";
  });
}

if (closeBtn) {
  // Hide the tooltip when the close button is clicked
  closeBtn.addEventListener("click", function (event) {
    event.stopPropagation(); // Prevents click event from reaching window listener
    tooltip.style.display = "none";
  });
}

// Remove the outside click listener to keep the tooltip open unless the button is clicked again




document.addEventListener("DOMContentLoaded", function (event) {
  // Get all videos
  var videos = document.getElementsByClassName("video__play-button");
  var video_fullscreen = document.getElementsByClassName(
    "video__fullscreen-button"
  );

  // Loop through all videos
  for (var i = 0; i < videos.length; i++) {
    // On click play button
    videos[i].onclick = function () {
      // Find video element
      video = this.nextElementSibling;
      video_wrapper = this.parentElement;
      console.log(video_wrapper);
      console.log(video);

      // Play video
      if (video.paused == true) {
        // Play the video
        video.play();
        video.setAttribute("data-state", "play");
        video.setAttribute("data-state-reload", "false");
        video_wrapper.setAttribute("data-state", "play");

        // Update the button text to 'Pause'
        // this.innerHTML = "Pause";
        this.setAttribute("data-button-state", "play");
        this.setAttribute("data-button-state-reload", "false");
      } else {
        // Pause the video
        video.pause();
        video.setAttribute("data-state", "pause");
        video_wrapper.setAttribute("data-state", "pause");

        // Update the button text to 'Play'
        // this.innerHTML = "Play";
        this.setAttribute("data-button-state", "pause");
      }

      // When video is ended
      video.onended = (event) => {
        // Pause the video
        video.setAttribute("data-state", "pause");
        video.setAttribute("data-state-reload", "true");

        // Update the button text to 'Play'
        this.setAttribute("data-button-state", "pause");
        this.setAttribute("data-button-state-reload", "true");
      };
    };
  }
  // Loop through all videos
  for (var i = 0; i < video_fullscreen.length; i++) {
    // On click play button
    video_fullscreen[i].onclick = function () {
      // Find video element
      video = this.nextElementSibling.nextElementSibling;

      if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullScreen) {
        video.webkitRequestFullScreen();
      }
    };
  }
});

$(window).on("scroll", function () {
  var footerOffset = $(".footer").offset().top;
  var windowScroll = $(window).scrollTop();
  var windowHeight = $(window).height();
  var hideOffset = 70;
  if (windowScroll + windowHeight >= footerOffset - hideOffset) {
    $(".product-sticky-form").fadeOut();
  } else {
    $(".product-sticky-form").fadeIn();
  }
});

$(document).ready(function () {
  if (window.location.href.indexOf("/policies") > -1) {
    $("body").addClass("policy_pages");
  }
  if (window.location.href.indexOf("pages/zahlungsarten") > -1) {
    $("body").addClass("template_zahlungs");
  }
  if (window.location.href.indexOf("pages/mitglied-im-handlerbund") > -1) {
    $("body").addClass("template_mitglied");
  }
  if (window.location.href.indexOf("/pages/") > -1) {
    $("body").addClass("template_for_all_page");
  }
});


$(document).ready(function () {
  setTimeout(function () {
    ratingSnippet("ruk_rating_snippet", {
      store: "gravurschmuck.de",
      mode: "extended",
      color: "#FCDF39",
      linebreak: false,
      text: "<span style='margin-left:-2.5px;' class='test_space'></span>",
      singularText: "",
      lang: "de",
      usePolaris: true,
      showEmptyStars: false,
    });
  }, 1000);
});

document.addEventListener("cart:updated", function () {
  setTimeout(function () {
    ratingSnippet("ruk_rating_snippet", {
      store: "gravurschmuck.de",
      mode: "extended",
      color: "#FCDF39",
      linebreak: false,
      text: "<span style='margin-left:-2.5px;' class='test_space'></span>",
      singularText: "",
      lang: "de",
      usePolaris: true,
      showEmptyStars: false,
    });
  }, 1000);
});

$(document).on("click", ".add_free_gift", function () {
  setTimeout(function () {
    ratingSnippet("ruk_rating_snippet", {
      store: "gravurschmuck.de",
      mode: "extended",
      color: "#FCDF39",
      linebreak: false,
      text: "<span style='margin-left:-2.5px;' class='test_space'></span>",
      singularText: "",
      lang: "de",
      usePolaris: true,
      showEmptyStars: false,
    });
  }, 3500);
  //  alert("Fffffff");
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener(
    "mouseenter",
    function (event) {
      if (
        event.target &&
        event.target.classList &&
        event.target.classList.contains("ruk_rating_snippet")
      ) {
        event.target.setAttribute(
          "data-title",
          event.target.getAttribute("title")
        );
        event.target.removeAttribute("title");
      }
    },
    true
  );

  document.addEventListener(
    "mouseleave",
    function (event) {
      if (
        event.target &&
        event.target.classList &&
        event.target.classList.contains("ruk_rating_snippet")
      ) {
        event.target.setAttribute(
          "title",
          event.target.getAttribute("data-title")
        );
      }
    },
    true
  );
});




